import { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../services/api';
import '../styles/AuthPage.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');
    try {
      const response = await auth.forgotPassword(email.trim());
      setMessage(response.message || 'If an account exists, a reset link will be sent.');
    } catch (err) {
      setError(err.userMessage || 'Could not send a reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='auth-page'>
      <div className='auth-modal'>
        <h2>Reset Password</h2>
        <form onSubmit={handleSubmit}>
          <input
            type='email'
            placeholder='Email'
            value={email}
            onChange={event => setEmail(event.target.value)}
            required
          />
          {error && <p className='auth-error'>{error}</p>}
          {message && <p>{message}</p>}
          <button type='submit' className='auth-btn' disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <p className='auth-switch'>
          <Link to='/auth?mode=login'>Back to log in</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
